import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth.slice";
import userReducer from "./user/user.slice";
import categoryReducer from "./category/category.slice";
import prayerReducer from "./prayer/prayer.slice";
import dashbaordReducer from "./dashoboard/dashboard.slice";
import tagReducer from "./tag/tag.slice";
import reviewReducer from "./review/review.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    category: categoryReducer,
    prayer: prayerReducer,
    dashboard: dashbaordReducer,
    tag: tagReducer,
    review: reviewReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
